(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eossia-collection"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(){
    var forms = document.querySelectorAll('.ecol-fform');
    var isMobile = window.matchMedia('(max-width:1000px)').matches;

    forms.forEach(function(form){
      form.classList.add('is-js');
      // Desktop : application auto au clic. Mobile : via le bouton « Voir les résultats »
      form.addEventListener('change', function(e){
        if(isMobile){ return; }
        var t = e.target;
        if(t && (t.type === 'checkbox' || t.type === 'number')){
          form.submit();
        }
      });
    });

    // Mobile : bouton « Filtres » qui déplie/replie tout le panneau d'un coup
    var mob = document.getElementById('ecol-mobtoggle');
    var side = document.getElementById('ecol-side');
    if(mob && side){
      mob.addEventListener('click', function(){
        var open = side.classList.toggle('is-open');
        mob.classList.toggle('is-open', open);
        mob.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    // Après filtrage sur mobile : recentrer sur les résultats au lieu de rester tout en haut
    if(isMobile && location.search.indexOf('filter.') > -1){
      var r = document.getElementById('ecol-results');
      if(r){ r.scrollIntoView({block:'start'}); }
    }
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
